import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
} from '@mui/material';

import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
// import { Autoplay } from 'swiper/modules';

import { LaunchSharp as LaunchSharpIcon } from '@mui/icons-material';

import clientMD from '~/content/svg/clients/mde.svg';
import clientRecord from '~/content/images/network/record_evolution.webp';
import client711 from '~/content/svg/clients/logo-711.webp';
import clientBayern from '~/content/svg/clients/bayern_staatsregierung.webp';

import { useTranslation } from 'react-i18next';

import { IframeModal } from '~/content/components/Modal/IframeModal';
import { useLoaderData } from '@remix-run/react';

const Partners = (): JSX.Element => {
	let { t } = useTranslation(['applications']);
	const theme = useTheme();
	const { mode } = theme.palette;
	const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
		defaultMatches: true,
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});
	const isLg = useMediaQuery(theme.breakpoints.up('lg'), {
		defaultMatches: true,
	});

	let slidesToShow = 2;
	if (isXs) {
		slidesToShow = 1;
	}
	if (isSm) {
		slidesToShow = 2;
	}
	if (isMd) {
		slidesToShow = 3;
	}
	if (isLg) {
		slidesToShow = 3;
	}

	const NextAndPrev = (props: any) => {
		const swiper = useSwiper();
		return (
			<Grid
				container
				direction='row'
				justifyContent={props.md ? 'flex-end' : 'center'}
				alignItems='center'
				spacing={4}
			>
				{/* <Grid container direction='column' justifyContent='flex-end' alignItems='center'> */}

				<Grid item xs={'auto'}>
					<Button
						variant='contained'
						aria-label='previous customer'
						// aria-labelledby='previous customer'
						// aria-describedby='slide to previous customer reference'
						color='primary'
						onClick={(e) => {
							e.preventDefault();
							swiper.slidePrev();
						}}
						style={{
							padding: '0px',
							paddingTop: '5px',
							paddingBottom: '5px',
						}}
					>
						<Box
							component={'svg'}
							xmlns='http://www.w3.org/2000/svg'
							fill='currentColor'
							viewBox='0 0 48 48'
							stroke='currentColor'
							width={24}
							height={24}
						>
							<path d='M28.05 36 16 23.95 28.05 11.9l2.15 2.15-9.9 9.9 9.9 9.9Z' />
						</Box>
					</Button>
				</Grid>

				<Grid item xs={'auto'}>
					<Button
						variant='contained'
						aria-label='next customer'
						// aria-labelledby='next customer'
						// aria-describedby='slide to next customer reference'
						color='primary'
						onClick={(e) => {
							e.preventDefault();
							swiper.slideNext();
						}}
						style={{
							padding: '0px',
							paddingTop: '5px',
							paddingBottom: '5px',
						}}
					>
						<Box
							component={'svg'}
							xmlns='http://www.w3.org/2000/svg'
							fill='currentColor'
							viewBox='0 0 48 48'
							stroke='currentColor'
							width={24}
							height={24}
						>
							<path d='m18.75 36-2.15-2.15 9.9-9.9-9.9-9.9 2.15-2.15L30.8 23.95Z' />
						</Box>
					</Button>
				</Grid>
			</Grid>
		);
	};

	const mock = [
		{
			description: t('customer_text_2'),
			companyLogo: client711,
			alt: 'API Entwicklung für FITSEVENELEVEN',
			button: t('customer_button_2'),
			url: 'https://starlight.astro.build/de/getting-started/',
			type: 'href',
			disable: true,
		},
		{
			description: t('customer_text_3'),
			title: 'Record Evolution GmbH',
			companyLogo: clientRecord,
			alt: 'iOS & Android Entwicklung für RecordEvolution App Store in Frankfurt',
			button: t('customer_button_3'),
			url: 'https://studio.ironflock.com/de/apps/SafetyWatch',
			type: 'href',
			disable: true,
		},
		{
			description: t('customer_text_4'),
			companyLogo: clientBayern,
			alt: 'Bayerischen Staatsregierung ist Kunde von NorthRock software für WebPortal',
			button: t('customer_button_4'),
			url: 'https://starlight.astro.build/de/getting-started/',
			type: 'href',
			disable: true,
		},
		{
			description: t('customer_text_1'),
			companyLogo: clientMD,
			alt: 'Anwendungsentwicklung und WebApp für MD Elektronik für Windows und macOS',
			button: t('customer_button_1'),
			url: 'https://app.demo.pre-release.md.hr-monitor.software?demo=U3RhcnRUaGVTeXN0ZW0',
			type: 'iframe',
			disable: false,
		},
	];

	const [iframeUrl, setIframeUrl] = useState('');
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
		<Box>
			<IframeModal
				open={open}
				handleClose={handleClose}
				handleOpen={handleOpen}
				// Then parse these -> username=DemoUser password=DEMO!123DEMO
				// URL='https://app.demo.pre-release.md.hr-monitor.software?demo=U3RhcnRUaGVTeXN0ZW0'
				URL={iframeUrl}
				id={undefined}
				headline='2'
			/>
			<Box marginBottom={{ sx: 5, md: 3 }}>
				<Typography variant={'h4'} sx={{ fontWeight: 700 }} align={'center'} gutterBottom>
					{t('customer_headline')}
				</Typography>

				<Typography
					variant={isMd ? 'h6' : 'body1'}
					component='p'
					color='text.secondary'
					align={'center'}
				>
					{t('customer_subheadline')}
				</Typography>
			</Box>

			<Swiper
				// navigation={true}
				loop={true}
				// mousewheel={true}
				allowTouchMove={false}
				simulateTouch={false}
				//  modules={[Navigation]}

				// allowSlideNext={true}
				// allowSlidePrev={true}
				// allowTouchMove={true}
				// noSwiping={true}
				// slidesPerView={slidesToShow}
				// spaceBetween={30}
				// slidesPerGroup={1}
				// loop={true}
				// speed={2000}
				// autoplay={{
				// 	delay: 5000,
				// 	disableOnInteraction: false,
				// 	pauseOnMouseEnter: false,
				// 	reverseDirection: false,
				// }}
				// loopFillGroupWithBlank={true}
				// pagination={{
				// 	clickable: true,
				// }}
				// navigation={true}
				// modules={[Autoplay]}
				// className='mySwiper'
			>
				{mock.map((item, i) => (
					// * changed height
					<SwiperSlide key={i}>
						<Box
							marginTop={{ xs: 1, md: 0 }}

							// component="img"
							// height={1}
							// width={1}
							// src={item.companyLogo}
							// alt="Kunden"
							// // marginX={2}
							// sx={{
							// 	filter: 'brightness(0) invert(1)'
							// }}
						/>
						<Box>
							<Box
								display={'block'}
								width={1}
								height={1}
								// sx={{
								//   textDecoration: "none",
								//   transition: "all .3s ease-in-out",
								//   "&:hover": {
								//     transform: `translateY(-${theme.spacing(1 / 2)})`,
								//   },
								// }}
							>
								<Box
									sx={{ boxShadow: 0, background: 'transparent' }}
									component={Card}
									width={1}
									height={1}
									borderRadius={0}
									display={'flex'}
									flexDirection={'column'}
								>
									<Box
										component={CardContent}
										display={'flex'}
										flexDirection={'column'}
										alignItems={'center'}
									>
										<Box height={50} width={'auto'} marginBottom={2}>
											<Box
												component='img'
												height={1}
												width={1}
												src={item.companyLogo}
												alt={item.alt}
												sx={{
													filter: mode === 'dark' ? 'brightness(0) invert(1)' : 'brightness(0)',
													objectFit: 'contain',
													maxHeight: '45px',
													width: 'auto',
												}}
											/>
										</Box>
										<Typography align={'center'} color='textSecondary'>
											{item.description}
										</Typography>
									</Box>

									<Box component={CardActions} justifyContent={'center'}>
										{item.type !== 'href' ? (
											// iframe button for desktop

											<Button
												sx={{
													display: item.disable || !isMd ? 'none' : 'flex',
												}}
												// disabled={isMd ? false : true}
												endIcon={
													<Box
														sx={{ position: 'relative', bottom: '2px' }}
														component={'svg'}
														xmlns='http://www.w3.org/2000/svg'
														fill='currentColor'
														viewBox='0 0 48 48'
														stroke='currentColor'
														width={18}
														height={18}
													>
														<path d='M10 38V26h3v9h9v3Zm25-16v-9h-9v-3h12v12Z' />
													</Box>
												}
												onClick={() => {
													setIframeUrl(item.url);

													handleOpen();
												}}
											>
												{item.button}
											</Button>
										) : (
											// href button for mobil

											<Button
												sx={{
													display: item.disable || !isMd ? 'none' : 'flex',
												}}
												href={item.url}
												target='_blank'
												endIcon={
													<Box
														sx={{
															display: 'inline-block',
															position: 'relative',
															width: '14px',
														}}
													>
														<LaunchSharpIcon
															sx={{
																fontSize: '14px',
																position: 'absolute',
																bottom: '-6px',
																left: '-2px',
																// backgroundcolor: 'text.secondary',
															}}
														/>
													</Box>
												}
											>
												{item.button}
											</Button>
										)}
									</Box>
								</Box>
							</Box>
						</Box>
					</SwiperSlide>
				))}
				<NextAndPrev md={isSm} />
			</Swiper>
		</Box>
	);
};

export default Partners;
